<template>
  <v-menu rounded offset-y px-0 min-width="150">
    <template v-slot:activator="{ on }">
      <v-chip
        v-on="isEditable ? on : null"
        :small="!large"
        class="chip"
        :data-testid="`statusChip-status-${status}`"
        :color="color"
      >
        <span class="caption" :class="textClass">{{ statusText }}</span>

        <ValidationIndicator
          v-if="showValidationIcons"
          :isRevValidatedStatus="isValidated"
          :isFinanciallyValidatedStatus="isFinanciallyValidated"
        />
        <v-icon v-if="isEditable" small :class="textClass"
          >mdi-chevron-down</v-icon
        >
      </v-chip>
    </template>
    <v-list nav dense class="mt-1 rounded">
      <v-list-item
        v-for="(statusItem, index) in availableStatus"
        link
        :class="{ 'selected-item': statusItem.value === status }"
        :data-testid="`statusChip-listItem-${statusItem.value}`"
        :key="index"
        @click="$emit('onChange', statusItem.value)"
      >
        <v-list-item-content class="py-0">
          <v-list-item-title class="blue-grey--text text--darken-2">{{
            statusItem.text
          }}</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
    </v-list>
  </v-menu>
</template>

<script>
import ValidationIndicator from './ValidationIndicator.vue'

export default {
  props: {
    statusText: {
      type: String,
      required: true,
    },
    status: {
      type: String,
      required: false,
    },
    availableStatus: {
      type: Array,
    },
    isEditable: {
      type: Boolean,
      default: false,
    },
    large: {
      type: Boolean,
      default: false,
    },
    textClass: {
      type: String,
      required: true,
    },
    color: {
      type: String,
      required: true,
    },
    isValidated: {
      type: Boolean,
      default: false,
    },
    isFinanciallyValidated: {
      type: Boolean,
      default: false,
    },
    showValidationIcons: {
      type: Boolean,
      default: false,
    },
  },
  components: { ValidationIndicator },
}
</script>

<style lang="scss" scoped>
.chip:before {
  background-color: inherit !important;
}
.selected-item {
  background: var(--blue-lighten2);
  .v-list-item__title {
    color: var(--v-blue);
  }
}
</style>
